export enum ProcessStates {
  RUNNING = 'R',
  SUCCESS = 'S',
  FAILED = 'F',
  CANCELED = 'C',
  QUEUED = 'Q',
}

export enum Processes {
  EssGeneration = 'essGeneration',
}
